export const SERIF_DISPLAY = '"EB Garamond", Garamond, "Hoefler Text", Cambria, Georgia, serif';
export const SERIF_BODY    = '"EB Garamond", Garamond, Cambria, Georgia, serif';
export const SERIF_GEORGIA = 'Georgia, "Iowan Old Style", Cambria, serif';
export const SERIF_CAMBRIA = 'Cambria, Cardo, Georgia, serif';
export const SANS_BODY     = '"Inter", "Helvetica Neue", Helvetica, Arial, sans-serif';
export const SANS_HUMANIST = 'Calibri, "Source Sans 3", "Source Sans Pro", "Segoe UI", sans-serif';
export const MONO_FACE     = '"JetBrains Mono", "IBM Plex Mono", Menlo, Consolas, monospace';

export const TEMPLATES = {
  'corporate-boardroom': {
    label: 'The Boardroom',
    blurb: 'Centered, banner headers, navy quarter-circle.',
    category: 'corporate',
    accent: '#1B2B47',
    nameFont: SERIF_DISPLAY,
    bodyFont: SERIF_BODY,
    nameAlign: 'center',
    nameStyle: 'uppercase-tracked',
    sectionStyle: 'banner',
    decorativeMark: 'corner-arc',
    italicTagline: true,
    density: 'normal',
  },
  'corporate-partner': {
    label: 'The Partner',
    blurb: 'Left-aligned name with hairline rule, small-caps headers.',
    category: 'corporate',
    accent: '#1B2B47',
    nameFont: SERIF_DISPLAY,
    bodyFont: SERIF_BODY,
    nameAlign: 'left',
    nameStyle: 'uppercase-tracked',
    sectionStyle: 'small-caps-rule',
    decorativeMark: 'name-rule',
    italicTagline: true,
    density: 'normal',
    tabularDates: true,
  },
  'tech-builder': {
    label: 'The Builder',
    blurb: 'Sans-serif throughout, small uppercase headers with thin rule.',
    category: 'tech',
    accent: '#3B5168',
    nameFont: SANS_BODY,
    bodyFont: SANS_BODY,
    nameAlign: 'left',
    nameStyle: 'sans-bold',
    sectionStyle: 'small-caps-rule',
    decorativeMark: 'name-rule',
    italicTagline: false,
    density: 'normal',
    monoSkills: true,
  },
  'tech-architect': {
    label: 'The Architect',
    blurb: 'Centered sans-serif, slate banners, inline tech pills.',
    category: 'tech',
    accent: '#3B5168',
    nameFont: SANS_BODY,
    bodyFont: SANS_BODY,
    nameAlign: 'center',
    nameStyle: 'sans-uppercase-tracked',
    sectionStyle: 'banner',
    decorativeMark: 'corner-arc',
    italicTagline: false,
    density: 'normal',
    pillSkills: true,
  },
  'creative-editorial': {
    label: 'The Editorial',
    blurb: 'Asymmetric: name left, contact right on same baseline.',
    category: 'creative',
    accent: '#A85432',
    accentSage: '#6B7F5C',
    nameFont: SERIF_CAMBRIA,
    bodyFont: SERIF_CAMBRIA,
    nameAlign: 'asymmetric',
    nameStyle: 'serif-display',
    sectionStyle: 'small-caps-italic',
    decorativeMark: 'thin-rule',
    italicTagline: true,
    italicRoles: true,
    density: 'normal',
    creativeTone: true,
  },
  'creative-studio': {
    label: 'The Studio',
    blurb: 'Centered name, italic taglines, soft tinted banners.',
    category: 'creative',
    accent: '#A85432',
    accentSage: '#6B7F5C',
    nameFont: SERIF_CAMBRIA,
    bodyFont: SERIF_CAMBRIA,
    nameAlign: 'center',
    nameStyle: 'serif-display',
    sectionStyle: 'banner-soft',
    decorativeMark: 'corner-arc',
    italicTagline: true,
    italicRoles: true,
    density: 'normal',
    creativeTone: true,
  },
  'healthcare-practitioner': {
    label: 'The Practitioner',
    blurb: 'Reference-style with teal banner headers.',
    category: 'healthcare',
    accent: '#2A6B6E',
    nameFont: SERIF_GEORGIA,
    bodyFont: SERIF_GEORGIA,
    nameAlign: 'center',
    nameStyle: 'uppercase-tracked',
    sectionStyle: 'banner',
    decorativeMark: 'corner-arc',
    italicTagline: true,
    density: 'normal',
    licensesProminent: true,
  },
  'healthcare-educator': {
    label: 'The Educator',
    blurb: 'Compact, left-aligned name with teal rule beneath.',
    category: 'healthcare',
    accent: '#2A6B6E',
    nameFont: SERIF_GEORGIA,
    bodyFont: SERIF_GEORGIA,
    nameAlign: 'left',
    nameStyle: 'serif-display',
    sectionStyle: 'small-caps-rule',
    decorativeMark: 'name-rule',
    italicTagline: true,
    density: 'compact',
  },
  'academic-scholar': {
    label: 'The Scholar',
    blurb: 'Formal centered, traditional banners, scholarly sections.',
    category: 'academic',
    accent: '#6B2737',
    nameFont: SERIF_DISPLAY,
    bodyFont: SERIF_BODY,
    nameAlign: 'center',
    nameStyle: 'uppercase-tracked',
    sectionStyle: 'banner',
    decorativeMark: 'corner-arc',
    italicTagline: true,
    density: 'normal',
  },
  'academic-researcher': {
    label: 'The Researcher',
    blurb: 'Compact CV density, small-caps with burgundy rule.',
    category: 'academic',
    accent: '#6B2737',
    nameFont: SERIF_DISPLAY,
    bodyFont: SERIF_BODY,
    nameAlign: 'left',
    nameStyle: 'uppercase-tracked',
    sectionStyle: 'small-caps-rule',
    decorativeMark: 'name-rule',
    italicTagline: true,
    density: 'compact',
    tabularDates: true,
  },
  'trades-operator': {
    label: 'The Operator',
    blurb: 'Bold left-aligned, charcoal banners with thin orange underline.',
    category: 'trades',
    accent: '#2D2D2D',
    accent2: '#C2511F',
    nameFont: SANS_HUMANIST,
    bodyFont: SANS_HUMANIST,
    nameAlign: 'left',
    nameStyle: 'sans-bold-uppercase',
    sectionStyle: 'banner-underline',
    decorativeMark: 'name-rule-orange',
    italicTagline: false,
    density: 'normal',
  },
  'trades-foreman': {
    label: 'The Foreman',
    blurb: 'Centered name, charcoal corner mark, certifications first.',
    category: 'trades',
    accent: '#2D2D2D',
    accent2: '#C2511F',
    nameFont: SANS_HUMANIST,
    bodyFont: SANS_HUMANIST,
    nameAlign: 'center',
    nameStyle: 'sans-bold-uppercase',
    sectionStyle: 'banner',
    decorativeMark: 'corner-arc',
    italicTagline: false,
    density: 'normal',
    licensesProminent: true,
  },

  'legal-counsel': {
    label: 'The Counsel',
    blurb: 'Centered serif with formal banners and slate corner mark.',
    category: 'legal',
    accent: '#2C3E50',
    nameFont: SERIF_DISPLAY,
    bodyFont: SERIF_BODY,
    nameAlign: 'center',
    nameStyle: 'uppercase-tracked',
    sectionStyle: 'banner',
    decorativeMark: 'corner-arc',
    italicTagline: true,
    density: 'normal',
    tabularDates: true,
  },
  'legal-advocate': {
    label: 'The Advocate',
    blurb: 'Left-aligned, compact layout with hairline rule accent.',
    category: 'legal',
    accent: '#2C3E50',
    nameFont: SERIF_DISPLAY,
    bodyFont: SERIF_BODY,
    nameAlign: 'left',
    nameStyle: 'uppercase-tracked',
    sectionStyle: 'small-caps-rule',
    decorativeMark: 'name-rule',
    italicTagline: true,
    density: 'compact',
    tabularDates: true,
  },

  'finance-analyst': {
    label: 'The Analyst',
    blurb: 'Clean sans-serif, monospaced skills, tabular date alignment.',
    category: 'finance',
    accent: '#1A3A2A',
    nameFont: SANS_BODY,
    bodyFont: SANS_BODY,
    nameAlign: 'left',
    nameStyle: 'sans-bold',
    sectionStyle: 'small-caps-rule',
    decorativeMark: 'name-rule',
    italicTagline: false,
    density: 'normal',
    tabularDates: true,
    monoSkills: true,
  },
  'finance-director': {
    label: 'The Director',
    blurb: 'Centered serif, forest-green banner headers with corner mark.',
    category: 'finance',
    accent: '#1A3A2A',
    nameFont: SERIF_DISPLAY,
    bodyFont: SERIF_BODY,
    nameAlign: 'center',
    nameStyle: 'uppercase-tracked',
    sectionStyle: 'banner',
    decorativeMark: 'corner-arc',
    italicTagline: true,
    density: 'normal',
  },

  'executive-chief': {
    label: 'The Chief',
    blurb: 'Commanding serif display, soft tinted banners, italic tagline.',
    category: 'executive',
    accent: '#1A1A1A',
    nameFont: SERIF_DISPLAY,
    bodyFont: SERIF_BODY,
    nameAlign: 'center',
    nameStyle: 'serif-display',
    sectionStyle: 'banner-soft',
    decorativeMark: 'thin-rule',
    italicTagline: true,
    italicRoles: true,
    density: 'normal',
  },
  'executive-strategist': {
    label: 'The Strategist',
    blurb: 'Asymmetric layout, italic small-caps headers, refined elegance.',
    category: 'executive',
    accent: '#1A1A1A',
    nameFont: SERIF_DISPLAY,
    bodyFont: SERIF_BODY,
    nameAlign: 'asymmetric',
    nameStyle: 'serif-display',
    sectionStyle: 'small-caps-italic',
    decorativeMark: 'thin-rule',
    italicTagline: true,
    italicRoles: true,
    density: 'normal',
  },
};

export const CATEGORIES = [
  { id: 'corporate',  label: 'Corporate',     variants: ['corporate-boardroom', 'corporate-partner'] },
  { id: 'tech',       label: 'Tech',          variants: ['tech-builder', 'tech-architect'] },
  { id: 'creative',   label: 'Creative',      variants: ['creative-editorial', 'creative-studio'] },
  { id: 'healthcare', label: 'Health / Edu',  variants: ['healthcare-practitioner', 'healthcare-educator'] },
  { id: 'academic',   label: 'Academic',      variants: ['academic-scholar', 'academic-researcher'] },
  { id: 'trades',     label: 'Trades',        variants: ['trades-operator', 'trades-foreman'] },
  { id: 'legal',      label: 'Legal',         variants: ['legal-counsel', 'legal-advocate'] },
  { id: 'finance',    label: 'Finance',       variants: ['finance-analyst', 'finance-director'] },
  { id: 'executive',  label: 'Executive',     variants: ['executive-chief', 'executive-strategist'] },
];

export const ACCENT_PRESETS = [
  { name: 'Navy',     value: '#1B2B47' },
  { name: 'Slate',    value: '#3B5168' },
  { name: 'Dark Slate', value: '#2C3E50' },
  { name: 'Teal',     value: '#2A6B6E' },
  { name: 'Forest',   value: '#2C5530' },
  { name: 'Ivy',      value: '#1A3A2A' },
  { name: 'Sage',     value: '#6B7F5C' },
  { name: 'Burgundy', value: '#6B2737' },
  { name: 'Plum',     value: '#4A2545' },
  { name: 'Clay',     value: '#A85432' },
  { name: 'Charcoal', value: '#2D2D2D' },
  { name: 'Black',    value: '#1A1A1A' },
];

export const TOOL_FONTS_CSS = `
  @import url('https://fonts.googleapis.com/css2?family=EB+Garamond:ital,wght@0,400;0,500;0,600;1,400&family=Inter:wght@400;500;600;700;800&family=Cormorant+Garamond:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap');

  .tool-display { font-family: 'Cormorant Garamond', 'EB Garamond', Garamond, serif; }
  .tool-body { font-family: 'Inter', system-ui, sans-serif; }

  .pdf-print-area {
    position: absolute;
    left: -99999px;
    top: 0;
    width: 8.5in;
    pointer-events: none;
  }

  .preview-scroll::-webkit-scrollbar { width: 10px; height: 10px; }
  .preview-scroll::-webkit-scrollbar-track { background: transparent; }
  .preview-scroll::-webkit-scrollbar-thumb { background: rgba(0,0,0,0.15); border-radius: 5px; }
  .preview-scroll::-webkit-scrollbar-thumb:hover { background: rgba(0,0,0,0.25); }
`;
